import React from 'react';
import { JxTooltip, JxTooltipRows, JxTooltipRowItemDescription } from '@jx';
import './UmlConnectorAnchorHandle.css';

// UmlConnectorAnchorHandle — klikzone op het start- of eindpunt van een connector.
// variant='start': zichtbaar vierkantje. variant='end': geen zichtbaar vormpje
// (de arrowHead-marker laat al zien dat dit het einde is), zelfde klikzone-grootte.
//
// Gewone drag = ankerpunt verschuiven langs de rand van de huidige shape (live,
// per mousemove). Ctrl(/Cmd)+drag = reattach naar een ANDERE shape (draft-lijn,
// hit-test bij loslaten) — zelfde patroon als het aanmaken van een nieuwe connector.
function UmlConnectorAnchorHandle({ variant, connector, onReattachDragStart }) {
    const handleMouseDown = (e) => {
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        connector?.selectAnchor(variant);
        onReattachDragStart?.(variant, e);
    };

    return (
        <JxTooltip
            title={
                <JxTooltipRows>
                    <JxTooltipRowItemDescription label="Drag" value="Move along border" />
                    <JxTooltipRowItemDescription label="Ctrl+drag" value="Reattach to shape" />
                </JxTooltipRows>
            }
        >
            <div className={`uml-connector-anchor-handle uml-connector-anchor-${variant}`} onMouseDown={handleMouseDown} />
        </JxTooltip>
    );
}

export default UmlConnectorAnchorHandle;
